import DPR from './DPR.js'

export default class EyedropperPopup {
  constructor() {
    this._elEyedropperPopup = document.querySelector('#eyedropperPopup');
    this._elEyedropperPopupColor = document.querySelector('#eyedropperPopup .color');
  }
  _update(color) {
    this._elEyedropperPopupColor.style.backgroundColor = `rgba(${color.join()})`;
  }
  _move(cursorX, cursorY) {
    this._elEyedropperPopup.style.left = `${DPR.div(cursorX)}px`;
    this._elEyedropperPopup.style.top = `${DPR.div(cursorY)}px`;
  }
  _popup() {
    this._elEyedropperPopup.classList.add('notransition');
    this._elEyedropperPopup.classList.add('hidden');
    this._toPopup = true;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if(this._toPopup) {
          this._elEyedropperPopup.classList.remove('notransition');
          this._elEyedropperPopup.classList.remove('hidden');
        }
      });
    });
  }
  _hide() {
    this._elEyedropperPopup.classList.add('hidden');
  }
  popup(color, cursorX, cursorY) {
    this._update(color);
    this._move(cursorX, cursorY);
    this._popup();
  };
  move(cursorX, cursorY) {
    this._move(cursorX, cursorY);
  };
  hide() {
    this._hide();
    this._toPopup = false;
  }
}
